import React from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

const MultiSelectDropdown = ({
  options,
  selectedValues,
  setSelectedValues,
  placeholder,
}) => {
  // Get button label based on selection
  const getDropdownButtonLabel = ({ placeholderButtonLabel, value }) => {
    if (value && value.some(option => option.value === "*")) {
      return `${placeholderButtonLabel}: All`;
    } else if (value.length === 0) {
      return `${placeholderButtonLabel}: None`;
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`;
    }
  };

  // Handle dropdown changes
  const onChange = (selected, event) => {
    if (event.action === "select-option" && event.option.value === "*") {
      // Select all options
      setSelectedValues([{ label: "All", value: "*" }, ...options]);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      // Deselect all options
      setSelectedValues([]);
    } else if (event.action === "deselect-option") {
      // Deselect specific options
      const updatedSelection = selected.filter(option => option.value !== "*");
      setSelectedValues(updatedSelection);
    } else if (selected.length === options.length) {
      // If all options are selected, select "All"
      setSelectedValues([{ label: "All", value: "*" }, ...options]);
    } else {
      setSelectedValues(selected);
    }
  };

  return (
    <ReactMultiSelectCheckboxes
      options={[{ label: "All", value: "*" }, ...options]} // Add "Select All"
      placeholderButtonLabel={placeholder} // Custom placeholder text
      getDropdownButtonLabel={getDropdownButtonLabel} // Custom label display
      value={selectedValues} // Current selected values
      onChange={onChange} // Change handler
    />
  );
};

export default MultiSelectDropdown;
